/*
 * @Description: 权限验证
 */
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import router from '@/router'
import { RouteLocationNormalized } from 'vue-router'
import { setToken, getToken } from '@/utils/cookies'
import { getQueryVariable } from '@/utils/validate'
import {whiteList} from '@/constant/whitelist'
import { useStore } from "@/store";
import { UserActionTypes } from "@/store/modules/user/action-types";
NProgress.configure({ showSpinner: false })
const infoToken = getQueryVariable('token')
const store = useStore();
if (infoToken) {
    setToken(infoToken,1)
}
if (getToken()) {
    store.dispatch(UserActionTypes.ACTION_GET_USER_INFO,undefined);
}
router.beforeEach(async (to: RouteLocationNormalized, _: RouteLocationNormalized, next: any) => {
    NProgress.start()
    if (getToken()) {
        next()
        if(to.meta.title !== '数据看板'){
            document.title = to.meta.title as string
        }
        NProgress.done()
    } else {
        if (whiteList.indexOf(to.path) !== -1) {
            next()
        } else {
            next(`/login`)
        }
        NProgress.done()
    }
})
